/* Eleganz-Karten: Elemente mit data-ej-href innerhalb der Karten-Links (z. B. Feingehalt →
   Karat-Kollektion) navigieren selbst. Capture-Phase, damit der umgebende Karten-Link
   nicht zuerst greift; Tastatur: Enter/Leertaste auf role="link". */
(function () {
  function go(event) {
    var el = event.target && event.target.closest ? event.target.closest('[data-ej-href]') : null;
    if (!el) return;
    event.preventDefault();
    event.stopPropagation();
    window.location.href = el.getAttribute('data-ej-href');
  }
  document.addEventListener('click', go, true);
  document.addEventListener('keydown', function (event) {
    if ((event.key === 'Enter' || event.key === ' ') && event.target.matches && event.target.matches('[data-ej-href]')) go(event);
  }, true);
})();
